import { Component } from 'react';

interface IProps {
  adBucketId?: string;
  adTypeTag?: string;
}

export default class SetMiffyBucket extends Component<IProps> {
  /**
   *
   */
  public componentDidMount() {
    window.miffy_bucket_id = this.props.adBucketId || '';
    window.miffy_type_tag = this.props.adTypeTag || '';
  }
  /**
   *
   */
  public render() {
    return null;
  }
}
